// initRebranding has to run first
// this allows us to call setWorkerAppRebrandingEnabled()@ui-theme before the theme is created
import "./initRebranding";
import "./global.scss";
import "./polyfills";
import { defineCustomElements } from "@ionic/pwa-elements/loader";
import { createRoot } from "react-dom/client";

import App from "./app/app";
import { AppRemountProvider, useAppRemount } from "./appV2/context/AppRemountContext";

function AppWrapper() {
  const { remountKey } = useAppRemount();
  return <App key={remountKey} />;
}

function Root() {
  return (
    <AppRemountProvider>
      <AppWrapper />
    </AppRemountProvider>
  );
}

const container = document.getElementById("root");
if (!container) {
  throw new Error("#root is not found");
}
const root = createRoot(container);
root.render(<Root />);

void defineCustomElements(window);
